<script setup lang="ts">
/**
 * 「AI 正在思考」占位。
 *
 * 只在 `streaming 且 content 为空` 时出现：一旦第一个 delta 到达，
 * 占位块必须立刻消失，否则会看到"灰条和真文字同时存在"。
 */

import Skeleton from './Skeleton.vue';
import SkeletonText from './SkeletonText.vue';
</script>

<template>
  <div class="flex flex-col gap-3" aria-hidden="true">
    <Skeleton class="h-3 w-24" />
    <SkeletonText :lines="4" />
  </div>
</template>
